var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWriteToUs = function SvgIconWriteToUs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5A855",
    d: "M1.5.5h15c.46 0 .833.373.833.833v13.334c0 .46-.373.833-.834.833h-15a.833.833 0 0 1-.833-.833V1.333c0-.46.373-.833.833-.833m14.166 3.532L9.059 9.948 2.333 4.013v9.82h13.333zM2.759 2.167 9.05 7.718l6.2-5.551z"
  })));
};
export default SvgIconWriteToUs;